import type { FormikProps } from 'formik'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { SettingsResponse } from '../../interfaces'
import { ImageSettingsLayout } from '../../layouts/Settings'

const ImageSettingsPage = (
  form: FormikProps<SettingsResponse>,
): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Image Settings</title>
      <meta name="description" content="Image Settings page" />
    </Helmet>
    <ImageSettingsLayout {...form} />
  </React.Fragment>
)

export default ImageSettingsPage
